import theme from '@/theme';
import styled from '@emotion/styled';

export const SceneTile = styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    border: 1px solid ${theme.colors.black[300]};
    cursor: pointer;

    img {
        display: block;
        width: 100%;
        height: auto;
    }

    &:hover:after {
        content: 'Apply scene';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.3);
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 600;
        z-index: 1;
    }
`;
